<template>
  <MetaButton data-testid="favorite-item" tooltip="Favorites" tooltip-placement="top" @click="onClick">
    <Icon data-testid="favorite-item-icon" :name="iconName" size="sm" :class="className" @mouseover="iconHovered = true" @mouseleave="iconHovered = false" />
  </MetaButton>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook/icon';
import MetaButton from '@/modules/viewer/components/MetaButton.vue';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { computed, ref } from 'vue';
import { TrackEvents, useTrack } from '@/composables/useTrack';

const viewerItemStore = useViewerItemStore();
const { id, favorite } = storeToRefs(viewerItemStore);
const { trackItemOwner } = useTrack();

const isSaving = ref<boolean>(false);
const iconHovered = ref<boolean>(false);
const iconName = computed(() => {
  // change icon based on hover state only if not favorite
  if (!favorite.value) {
    if (iconHovered.value) {
      return 'general.favoritesSolid';
    }
    return 'general.favorites';
  }
  return favorite.value ? 'general.favoritesSolid' : 'general.favorites';
});

const onClick = async () => {
  if (isSaving.value) {
    return;
  }

  trackItemOwner(TrackEvents.ITEM_ADD_TO_FAVORITES);

  isSaving.value = true;
  await viewerItemStore.toggleFavorite(id.value);
  isSaving.value = false;
};

const className = computed(() => {
  const classList = [`cursor-pointer favorite-subheader-item`];
  if (favorite.value) {
    classList.push(`text-copernicus-yellow`);
  }
  return classList.join(' ');
});
</script>
